jQuery(document).ready(function($) {
   
 
    $(".mattress_product_con .morelink").click(function(){
        if($(this).hasClass("less")) {
            $(this).removeClass("less");
            $(this).html(moretext);
			$(this).parent().prev().toggle();
			$(this).prev().css('display','none');
        } else {
            $(this).addClass("less");
            $(this).html(lesstext);
			$(this).parent().prev().toggle();
			$(this).prev().css('display','inline');
        }
        return false;
    });
  
    $('.read_more_description').click(function(e){
        e.preventDefault();
      	if($(this).text() == "Read More") $(this).html("Read Less");
   		else $(this).html("Read More");
		$('.mobile_section_faq .more_content').toggle();
    });
  
 	 $('.banner_more_content').click(function(e){
        e.preventDefault();
      	if($(this).text() == "Read More") $(this).html("Read Less");
   		else $(this).html("Read More");
		$('.banner_mobile_more_content').toggle();
    });
 
});